import {
  unit_name,
  unit_type,
  segment,
  region,
  country,
  siteCode,
  Enterprise,
  responsible_segment,
  responsible_division,
  responsible_division_id,
  business_unit_id,
  business_unit,
  sub_business_unit_id
} from "./Options";

export const AuditData = {
  unitDetails: [
    {
      id: 1,
      label: "Unit Index (3 Digit) and Unit Name",
      type: "select",
      options: unit_name.map((item) => ({
        value: item,
        label: item,
      })),
      name: "unitIndex",
      required: false, // Required field
      disable: false,
    },
    {
      id: 2,
      label: "Unit Type",
      type: "text",
      placeholder: "select Unit Type",
      name: "unitType",
      required: true, // Required field
      disable: true,
    },
    {
      id: 3,
      label: "Manufacturing Code (3 Letter) (if applicable)",
      type: "text",
      name: "manufacturingCode",
      required: true, // Optional field
      disable: true,
    },
    {
      id: 4,
      label: "Quality Manager or Lead Auditee ",
      type: "text",
      placeholder: "Enter name",
      name: "qualityManager",
      required: true, // Required field
      disable: true,
    },
    {
      id: 5,
      label: "Quality Manager or Lead Auditee Email",
      type: "email",
      placeholder: "Enter Email",
      name: "qualityManagerEmail",
      required: true, // Required field
      disable: true,
    },
    {
      id: 6,
      label: "Current Third Party Certifications Held",
      type: "select",
      options: [
        {
          value: "FSSC 22000 Additional Requirements (Version 6.0)",
          label: "FSSC 22000 Additional Requirements (Version 6.0)",
        },
        {
          value: "ISO 22000: 2018 Food Safety Management Systems",
          label: "ISO 22000: 2018 Food Safety Management Systems",
        },
        { value: "ISO 9001: 2018", label: "ISO 9001: 2018" },
        { value: "HACCP- Codex", label: "HACCP- Codex" },
        { value: "GMP/GHP", label: "GMP/GHP" },
        { value: "COSTCO", label: "COSTCO" },
        { value: "None", label: "None" },
      ],
      name: "certifications",
      required: true, // Optional field
      disable: false,
    },
    // {
    //   id: 7,
    //   label: "Parent Unit Name",
    //   type: "text",
    //   placeholder: "Enter Name",
    //   name: "parentUnit",
    //   required: true, // Required field
    // },
    {
      id: 8,
      label: "Unit Country",
      type: "text",
      name: "unitCountry",
      required: true, // Required field
      disable: true,
    },
    {
      id: 9,
      label: "Unit Region",
      type: "text",
      name: "unitRegion",
      required: true, // Optional field
      disable: true,
    },
    {
      id: 10,
      label: "CB Name",
      type: "select",
      options: [
        {
          value: "BV",
          label: "Bureau Veritas (BV)",
        },
        {
          value: "LRQA",
          label: "Llyod's Register Quality Assurance (LRQA)",
        },
        {
          value: "BSI",
          label: "British Standards Institution (BSI)",
        },
      ],
      name: "cbName",
      required: true, // Optional field
      disable: false,
    },
    {
      id: 11,
      label: "Enterprise",
      type: "text",
      name: "enterprise",
      required: true, // Required field
      disable: true,
    },
    {
      id: 12,
      label: "Responsible Segment",
      type: "text",
      name: "responsibleSegment",
      required: true, // Required field
      disable: true,
    },
    {
      id: 13,
      label: "Responsible Division",
      type: "text",
      name: "responsibleDivision",
      required: true, // Required field
      disable: true,
    },
    // {
    //   id: 14,
    //   label: "Responsible Division ID",
    //   type: "select",
    //   options: responsible_division_id.map((item) => ({
    //     value: item,
    //     label: item,
    //   })),
    //   name: "responsibleDivisionId",
    //   required: true, // Required field
    //   disable: true,
    // },
    // {
    //   id: 15,
    //   label: "Business Unit ID",
    //   type: "select",
    //   options: business_unit_id.map((item) => ({
    //     value: item,
    //     label: item,
    //   })),
    //   name: "businessUnitId",
    //   required: true, // Required field
    //   disable: true,
    // },
    {
      id: 16,
      label: "Business Unit",
      type: "text",
      name: "businessUnit",
      required: true, // Required field
      disable: true,
    },
    {
      id: 17,
      label: "Sub Business Unit",
      type: "text",
      name: "subBusinessUnit",
      required: true, // Required field
      disable: true,
    },
  ],
  offSiteFields: [
    {
      id: 1,
      label: "Off-Site Activities (if applicable)",
      type: "radio",
      options: ["Yes", "No"],
      name: "offSiteActivities",
      required: false,
      
    },
    {
      id: 2,
      label: "Type of Off-Site Activity",
      type: "text",
      placeholder: "Enter Off-Site Activity",
      name: "offsiteActivity",
      required: false,
    },
    {
      id: 3,
      label: "Is Location Currently Audited?",
      type: "radio",
      options: ["Yes", "No"],
      name: "locationAudited",
      required: true,
    },
    {
      id: 4,
      label: "Site Name",
      type: "text",
      placeholder: "Enter Name",
      name: "siteName",
      required: true,
    },
    {
      id: 5,
      label: "If Yes - Who is Auditing Location",
      type: "text",
      placeholder: "Enter Text",
      name: "AuditingLocation",
      required: true,
    },
  ],
};
